export const DiZhiArray = ["子", "丑", "寅", "卯", "辰", "巳", "午", "未", "申", "酉", "戌", "亥"]

// 地支拼音数组（与 DiZhiArray 索引对应）
export const DiZhiPinyin = ["zi", "chou", "yin", "mao", "chen", "si", "wu", "wei", "shen", "you", "xu", "hai"] as const;

// 地支类型
export type DiZhiKey = typeof DiZhiPinyin[number];

// 中文地支 → 拼音
export const DiZhiToPinyin: Record<string, DiZhiKey> = {
    "子": "zi", "丑": "chou", "寅": "yin", "卯": "mao",
    "辰": "chen", "巳": "si", "午": "wu", "未": "wei",
    "申": "shen", "酉": "you", "戌": "xu", "亥": "hai"
};

// 拼音 → 中文地支
export const PinyinToDiZhi: Record<DiZhiKey, string> = {
    "zi": "子", "chou": "丑", "yin": "寅", "mao": "卯",
    "chen": "辰", "si": "巳", "wu": "午", "wei": "未",
    "shen": "申", "you": "酉", "xu": "戌", "hai": "亥"
};
// 地支六合
export const LiuHe = {
    "子": "丑",
    "丑": "子",
    "寅": "亥",
    "卯": "戌",
    "辰": "酉",
    "巳": "申",
    "午": "未",
    "未": "午",
    "申": "巳",
    "酉": "辰",
    "戌": "卯",
    "亥": "寅"
}
// 地支六冲
export const LiuChong = {
    "子": "午",
    "丑": "未",
    "寅": "申",
    "卯": "酉",
    "辰": "戌",
    "巳": "亥",
    "午": "子",
    "未": "丑",
    "申": "寅",
    "酉": "卯",
    "戌": "辰",
    "亥": "巳"
}
// 地支顺序
export const DiZhiIndex = {
    1: "子",
    2: "丑",
    3: "寅",
    4: "卯",
    5: "辰",
    6: "巳",
    7: "午",
    8: "未",
    9: "申",
    10: "酉",
    11: "戌",
    12: "亥"
}

export const DiZhiNumber = {
    "子": 1,
    "丑": 2,
    "寅": 3,
    "卯": 4,
    "辰": 5,
    "巳": 6,
    "午": 7,
    "未": 8,
    "申": 9,
    "酉": 10,
    "戌": 11,
    "亥": 12
}
export const TianGanArray = ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸"]
export const TianGanIndex = {
    "甲": 0 + 1,
    "乙": 1 + 1,
    "丙": 2 + 1,
    "丁": 3 + 1,
    "戊": 4 + 1,
    "己": 5 + 1,
    "庚": 6 + 1,
    "辛": 7 + 1,
    "壬": 8 + 1,
    "癸": 9 + 1
}
export const TianGanNumber = {
    1: "甲",
    2: "乙",
    3: "丙",
    4: "丁",
    5: "戊",
    6: "己",
    7: "庚",
    8: "辛",
    9: "壬",
    10: "癸"
}
export const GanZhiYinYang = {
    "子": "阳",
    "丑": "阴",
    "寅": "阳",
    "卯": "阴",
    "辰": "阳",
    "巳": "阴",
    "午": "阳",
    "未": "阴",
    "申": "阳",
    "酉": "阴",
    "戌": "阳",
    "亥": "阴",
    "甲": "阳",
    "乙": "阴",
    "丙": "阳",
    "丁": "阴",
    "戊": "阳",
    "己": "阴",
    "庚": "阳",
    "辛": "阴",
    "壬": "阳",
    "癸": "阴",
}
export const TianGanWuHe = {
    "甲": "己",
    "乙": "庚",
    "丙": "辛",
    "丁": "壬",
    "戊": "癸",
    "己": "甲",
    "庚": "乙",
    "辛": "丙",
    "壬": "丁",
    "癸": "戊",
}
export const SanHeFaYong = {
    "巳": "酉",
    "酉": "丑",
    "丑": "巳",
    "申": "子",
    "子": "辰",
    "辰": "申",
    "寅": "午",
    "午": "戌",
    "戌": "午",
    "亥": "卯",
    "卯": "未",
    "未": "亥",
}
export const SanXingYong = {
    "丑": "戌",
    "戌": "未",
    "未": "戌",
    "寅": "巳",
    "巳": "申",
    "申": "寅",
    "子": "卯",
    "卯": "子",
    "辰": "辰",
    "午": "午",
    "酉": "酉",
    "亥": "亥",
}
